import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import style from '../css/AddAgent.module.css';
import HeaderBarBack from '../components/HeaderBarBack';

const AddAgent = () => {
	const navigate = useNavigate();

	// Form state
	const [formData, setFormData] = useState({
		name: '',
		phone: '',
		email: '',
		address: '',
		agent_id: '',
		doj: '',
		dol: '--',
		age: '',
		aadhar: '',
		emergency: '',
		password: '',
	});

	// Handle input change
	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();

		// Check if all fields are filled
		if (Object.values(formData).some((value) => !value)) {
			alert('Please fill in all required fields');
			return;
		}

		try {
			const response = await axios.post(
				'https://hometech-repairs.in/homeTech/addAgent.php',
				formData,
				{ headers: { 'Content-Type': 'application/json' } }
			);

			if (response.data.status) {
				alert('Agent added successfully');
				navigate('/agents');
			} else {
				alert(`Error: ${response.data.msg}`);
			}
		} catch (error) {
			console.error(
				'Error:',
				error.response ? error.response.data : error.message
			);
			alert('An error occurred. Please try again.');
		}
	};

	return (
		<div className={style.container}>
			<HeaderBarBack title={'New'} />
			<form onSubmit={handleSubmit}>
				<input
					type="text"
					name="name"
					placeholder="Name"
					value={formData.name}
					onChange={handleChange}
					required
				/>
				<input
					type="tel"
					name="phone"
					placeholder="Phone"
					value={formData.phone}
					onChange={handleChange}
					required
				/>
				<input
					type="email"
					name="email"
					placeholder="Email"
					value={formData.email}
					onChange={handleChange}
					required
				/>
				<input
					type="text"
					name="address"
					placeholder="Address"
					value={formData.address}
					onChange={handleChange}
					required
				/>
				<input
					type="text"
					name="agent_id"
					placeholder="Agent ID"
					value={formData.agent_id}
					onChange={handleChange}
					required
				/>
				<input
					type="date"
					name="doj"
					placeholder="Date of Joining"
					value={formData.doj}
					onChange={handleChange}
					required
				/>
				<input
					type="text"
					name="dol"
					placeholder="Date of Leaving"
					value={formData.dol}
					onChange={handleChange}
					hidden
				/>
				<input
					type="number"
					name="age"
					placeholder="Age"
					value={formData.age}
					onChange={handleChange}
					required
				/>
				<input
					type="number"
					name="aadhar"
					placeholder="Aadhar Number"
					value={formData.aadhar}
					onChange={handleChange}
					required
				/>
				<input
					type="text"
					name="emergency"
					placeholder="Emergency Contact"
					value={formData.emergency}
					onChange={handleChange}
					required
				/>
				<input
					type="password"
					name="password"
					placeholder="Password"
					value={formData.password}
					onChange={handleChange}
					required
				/>

				<button type="submit" className={style.submitButton}>
					Submit
				</button>
			</form>
		</div>
	);
};

export default AddAgent;
